// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ABCWhyteInktrap-Book.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "WhyteInktrap";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
* {
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

html, body {
  color: #222228;
}

.Validations_loader__L\\+yPX {
  display: flex;
  align-items: center;
  margin-top: 50px;
  flex-direction: column;
}
@keyframes Validations_spinner__F-8Ay {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.Validations_loader__L\\+yPX .Validations_spinner__F-8Ay {
  animation: Validations_spinner__F-8Ay 1s linear infinite;
  background: #23A0E5;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  position: relative;
  flex-shrink: 0;
  margin-bottom: 20px;
}
.Validations_loader__L\\+yPX .Validations_spinner__F-8Ay::before, .Validations_loader__L\\+yPX .Validations_spinner__F-8Ay::after {
  content: "";
  position: absolute;
}
.Validations_loader__L\\+yPX .Validations_spinner__F-8Ay::before {
  border-radius: 50%;
  background: linear-gradient(0deg, hsl(0, 0%, 100%) 50%, hsla(0, 0%, 100%, 0.9) 100%) 0 0 no-repeat, linear-gradient(90deg, hsla(0, 0%, 100%, 0.9) 0%, hsla(0, 0%, 100%, 0.6) 100%) 100% 0 no-repeat, linear-gradient(180deg, hsla(0, 0%, 100%, 0.6) 0%, hsla(0, 0%, 100%, 0.3) 100%) 100% 100% no-repeat, linear-gradient(360deg, hsla(0, 0%, 100%, 0.3) 0%, hsla(0, 0%, 100%, 0) 100%) 0 100% no-repeat;
  background-size: 50% 50%;
  top: -1px;
  bottom: -1px;
  left: -1px;
  right: -1px;
}
.Validations_loader__L\\+yPX .Validations_spinner__F-8Ay::after {
  background: white;
  border-radius: 50%;
  top: 15%;
  bottom: 15%;
  left: 15%;
  right: 15%;
}
.Validations_loader__L\\+yPX span {
  color: #23A0E5;
  font-weight: 500;
}

.Validations_error__Pk4n4 {
  color: #C60C30;
}

.Validations_validationContainer__v8pSV {
  padding: 0 100px;
  display: flex;
  flex-direction: column;
}
.Validations_validationContainer__v8pSV .Validations_rowWrapper__qk2Ub {
  width: 100%;
  display: flex;
  row-gap: 10px;
  flex-direction: column;
}
.Validations_validationContainer__v8pSV .Validations_rowWrapper__qk2Ub .Validations_firstRow__1\\+inV {
  display: flex;
  column-gap: 10px;
}
.Validations_validationContainer__v8pSV .Validations_rowWrapper__qk2Ub .Validations_filtersWrapper__IhYkO {
  display: flex;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  column-gap: 10px;
  margin-bottom: 16px;
}
.Validations_validationContainer__v8pSV .Validations_rowWrapper__qk2Ub .Validations_filtersWrapper__IhYkO.Validations_activeFilters__u1DBe {
  max-height: 40px;
  overflow: visible;
  display: flex;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}
.Validations_validationContainer__v8pSV .Validations_noData__isL4j {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}`, "",{"version":3,"sources":["webpack://./src/core/styles.scss","webpack://./src/views/Validations/Validations.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,+DAAA;ACCF;AD0BA;EACE,sBAAA;EACA,gCAzBS;ACCX;;AD2BA;EACE,cAVY;ACdd;;AATA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAYF;AAVE;EACE;IAAO,uBAAA;EAaT;EAZE;IAAO,yBAAA;EAeT;AACF;AAbE;EACE,wDAAA;EACA,mBDHG;ECIH,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAeJ;AAbI;EAEE,WAAA;EACA,kBAAA;AAcN;AAXI;EACE,kBAAA;EACA,wYAAA;EACA,wBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAaN;AAVI;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAYN;AARE;EACE,cDtCG;ECuCH,gBAAA;AAUJ;;AANA;EACE,cDvCI;ACgDN;;AANA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AASF;AAPE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AASJ;AAPI;EACE,aAAA;EACA,gBAAA;AASN;AANI;EACE,aAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAQN;AANM;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,oCAAA;AAQR;AAHE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAKJ","sourcesContent":["@font-face {\n  font-family: 'WhyteInktrap';\n  src: url('./../assets/fonts/ABCWhyteInktrap-Book.otf') format('opentype');\n}\n\n//FONTS\n$mainFont: 'Inter', sans-serif;\n$secondaryFont: 'WhyteInktrap', sans-serif;\n\n// COLORS\n$lightBlue: #DDEAFB;\n$mediumBlue: #B4E1FA;\n$blue: #23A0E5;\n$darkBlue: #60748E;\n$lightGrey: #EAECF0;\n$lightOrange: rgba(250, 182, 145, 0.76);\n$orange: #FF7427;\n$red: #C60C30;\n$plusGreen: #EBFF99;\n$lightGreen: #7ADDAF;\n$green: #007940;\n$darkGreen: #112C22;\n$purple: #D7B7FF;\n$lightPurple: #DBD7FC;\n\n$primaryDark: #222228;\n$secondaryDark: #122D62;\n$white: #FFFFFF;\n\n* {\n  box-sizing: border-box;\n  font-family: $mainFont;\n}\n\nhtml, body {\n  color: $primaryDark;\n}","@import '../../core/styles';\n\n.loader {\n  display: flex;\n  align-items: center;\n  margin-top: 50px;\n  flex-direction: column;\n\n  @keyframes spinner {\n    from { transform: rotate(0deg);   }\n    to   { transform: rotate(360deg); }\n  }\n\n  .spinner {\n    animation: spinner 1s linear infinite;\n    background: $blue;\n    border-radius: 50%;\n    height: 50px;\n    width: 50px;\n    position: relative;\n    flex-shrink: 0;\n    margin-bottom: 20px;\n\n    &::before,\n    &::after {\n      content: '';\n      position: absolute;\n    }\n\n    &::before {\n      border-radius: 50%;\n      background: linear-gradient(0deg, hsla(0, 0%, 100%, 1) 50%, hsla(0, 0%, 100%, 0.9) 100%) 0 0 no-repeat, linear-gradient(90deg, hsla(0, 0%, 100%, 0.9) 0%, hsla(0, 0%, 100%, 0.6) 100%) 100% 0 no-repeat, linear-gradient(180deg, hsla(0, 0%, 100%, 0.6) 0%, hsla(0, 0%, 100%, 0.3) 100%) 100% 100% no-repeat, linear-gradient(360deg, hsla(0, 0%, 100%, 0.3) 0%, hsla(0, 0%, 100%, 0) 100%) 0 100% no-repeat;\n      background-size: 50% 50%;\n      top: -1px;\n      bottom: -1px;\n      left: -1px;\n      right: -1px;\n    }\n\n    &::after {\n      background: white;\n      border-radius: 50%;\n      top: 15%;\n      bottom: 15%;\n      left: 15%;\n      right: 15%;\n    }\n  }\n\n  span {\n    color: $blue;\n    font-weight: 500;\n  }\n}\n\n.error {\n  color: $red;\n}\n\n.validationContainer {\n  padding: 0 100px;\n  display: flex;\n  flex-direction: column;\n\n  .rowWrapper {\n    width: 100%;\n    display: flex;\n    row-gap: 10px;\n    flex-direction: column;\n\n    .firstRow {\n      display: flex;\n      column-gap: 10px;\n    }\n\n    .filtersWrapper {\n      display: flex;\n      opacity: 0;\n      max-height: 0;\n      overflow: hidden;\n      column-gap: 10px;\n      margin-bottom: 16px;\n\n      &.activeFilters {\n        max-height: 40px;\n        overflow: visible;\n        display: flex;\n        opacity: 1;\n        transition: opacity 0.3s ease-in-out;\n      }\n    }\n  }\n\n  .noData {\n    display: flex;\n    justify-content: center;\n    margin-top: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `Validations_loader__L+yPX`,
	"spinner": `Validations_spinner__F-8Ay`,
	"error": `Validations_error__Pk4n4`,
	"validationContainer": `Validations_validationContainer__v8pSV`,
	"rowWrapper": `Validations_rowWrapper__qk2Ub`,
	"firstRow": `Validations_firstRow__1+inV`,
	"filtersWrapper": `Validations_filtersWrapper__IhYkO`,
	"activeFilters": `Validations_activeFilters__u1DBe`,
	"noData": `Validations_noData__isL4j`
};
export default ___CSS_LOADER_EXPORT___;
